import React, {useEffect, useState} from 'react'
import styled from "styled-components";

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    @media (max-width: 640px) {
    flex-direction: column;
  }
`

export const Wrapper = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    
    @media (max-width: 640px) {
    padding: 2em;
   
    }
`
export const Column = styled.div`
    //border: 1px dotted grey;
    flex-grow: 1;
    flex-basis: 0;
    // margin: 0 auto;
  

`
export const Button = styled.div`
  background: rgba(0,0,0,0.8);
  cursor: pointer;
  text-align: center;
  padding: .8em .5em;
  font-size: 1.5em;
  color: white;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: .1em;
`

export const BackgroundImg = styled.div`
    background: url(${(props) => props.src}) ${props => props.middle ? 'center' : 'top' };
    ${props => props.fill ? 'background-image: linear-gradient(45deg, transparent 25%, #ebebeb 25%, #ebebeb 50%, transparent 50%, transparent 75%, #ebebeb 75%, #ebebeb 100%);' : 'background: red;'}
    background-size: cover;
    transition: all ease .4s;
    ${props => props.height ? 'height: '+props.height+';' : '' }
    
    ${props => props.width ? 'width: '+props.width+';' : '' }
    
    ${props => props.hover ? '&:hover{height:calc('+props.height+' + 10px);width:calc('+props.width+' + 10px)}' : ''}
`